import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {ref, getCurrentInstance, watch, onMounted} from "vue";
import {createAuthenticationService} from '@/services/authenticationService';
import {createCandidateService} from '@/services/candidateService';
import {useRouter} from 'vue-router';
import { useRoute } from 'vue-router';
import { useLocalStorageStore } from "@/stores/localStorage";
import { storeToRefs } from "pinia";
import Login from './Login.vue';
import VerifyEmail from './VerifyEmail.vue';
import EmailVerified from './EmailVerified.vue';
import RegistrationFinance from './finance/Registration.vue';
import RegistrationTech from './tech/Registration.vue';
import RegistrationPopUp from './RegistrationPopUp.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginRegistrationFlow',
  setup(__props, { expose: __expose }) {

const loginDialog = ref<InstanceType<typeof Login>>();
const financeRegistrationDialog = ref<InstanceType<typeof RegistrationFinance>>();
const techRegistrationDialog = ref<InstanceType<typeof RegistrationTech>>();
const app = getCurrentInstance();
const router = useRouter();
const route = useRoute();
const postRegistration = ref();
const authenticationService = createAuthenticationService(app);
const verifyEmail = ref();
const emailVerified = ref();
const loadRegistrationPopup = ref(false);
const { isTechScope } = storeToRefs(useLocalStorageStore());

let callback: (() => any) | null = null;

const logout = () => {
    authenticationService.signOut();
    openLoginDialog(null, {});
}

const openLoginDialog = (logged_in_callback: (() => any) | null, loginOptions: any | null) => {
    callback = logged_in_callback;

    if (loginDialog.value == null) return;
    
    const loginDialogOptions = {...loginOptions, isTech: isTechScope.value}
    if (loginDialogOptions.email)
        loginDialog.value.showWithEmail(loginDialogOptions.email, loginDialogOptions);
    else
        loginDialog.value.show(loginDialogOptions);
    if (techRegistrationDialog.value != null) techRegistrationDialog.value.close();
    if (financeRegistrationDialog.value != null) financeRegistrationDialog.value.close();
};

const openRegistrationDialog = (email) => {
    if (isTechScope.value) {
        if (techRegistrationDialog.value != null) techRegistrationDialog.value.show(email);
    } else {
        if (financeRegistrationDialog.value != null) financeRegistrationDialog.value.show(email);
    }
    if (loginDialog.value != null) loginDialog.value.close();
};

onMounted(async () => {
    if (route.name !== "Direct") {
        await updateState();
    }
});

    const emailVerifiedEvent = async () => {
        const params = new URLSearchParams(window.location.search);
        const emailVerifiedTokenParam = params.get("email-verified-token");
        if (emailVerifiedTokenParam) {
            const token = decodeURIComponent(emailVerifiedTokenParam);

            await router.replace(window.location.pathname);

            const email = await authenticationService.loginAfterVerification(token);

            if (!authenticationService.isAuthenticated()) {
                await openLoginDialog(null, { email: email });
                return;
            } else {
                loadDashboard();
            }
        }
    }

const loadDashboard = () => {
    router.push({ name: 'Dashboard' });
}

const updateState = async () => {
    const params = new URLSearchParams(window.location.search);

    const emailVerifiedTokenParam = params.get("email-verified-token");
    if (emailVerifiedTokenParam) {
        const token = decodeURIComponent(emailVerifiedTokenParam);

        await router.replace(window.location.pathname);

        const email = await authenticationService.loginAfterVerification(token);

        if (!authenticationService.isAuthenticated()) {
            await openLoginDialog(null, {email: email});
            return;
        } else {
            loadDashboard();
        }
    }

    if (!authenticationService.isAuthenticated()) {
        return;
    }

    const candidateService = await createCandidateService(app);
    const isRegistered = await candidateService.isRegistered();
    if (!isRegistered) {
        if (window.location.pathname != '/agb' && window.location.pathname != '/datenschutz') {
            if (!postRegistration.value) {
                loadRegistrationPopup.value = true;
                const stop = watch(postRegistration, () => {
                        postRegistration.value.show();
                        stop();
                    }
                );
            } else {
                postRegistration.value.show();
            }
        }
        return;
    }

    const user = await authenticationService.getUser();
    if (user && user.email_verified) {
        if (callback) callback();
    } else {
        verifyEmail.value.show();
    }
}

__expose({
    openLoginDialog,
    openRegistrationDialog
});

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast),
    _createVNode(Login, {
      ref_key: "loginDialog",
      ref: loginDialog,
      onRegister: openRegistrationDialog,
      onLoggedIn: loadDashboard
    }, null, 512),
    _createVNode(RegistrationFinance, {
      ref_key: "financeRegistrationDialog",
      ref: financeRegistrationDialog,
      onRegistered: updateState,
      onLogin: openLoginDialog
    }, null, 512),
    _createVNode(RegistrationTech, {
      ref_key: "techRegistrationDialog",
      ref: techRegistrationDialog,
      isDirectSignUp: false,
      onRegistered: updateState,
      onLogin: openLoginDialog
    }, null, 512),
    (loadRegistrationPopup.value)
      ? (_openBlock(), _createBlock(RegistrationPopUp, {
          key: 0,
          ref_key: "postRegistration",
          ref: postRegistration,
          onSubmitted: updateState
        }, null, 512))
      : _createCommentVNode("", true),
    _createVNode(VerifyEmail, {
      ref_key: "verifyEmail",
      ref: verifyEmail,
      onEmailVerified: emailVerifiedEvent,
      onError: logout
    }, null, 512),
    _createVNode(EmailVerified, {
      ref_key: "emailVerified",
      ref: emailVerified
    }, null, 512)
  ], 64))
}
}

})